import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import ActionButton from '../../assets/buttons/ActionButton';

import { login } from '../../store/actions';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },

  dense: {
    marginTop: theme.spacing(2)
  },
  menu: {
    width: 200
  }
}));

const Login = ({ history, login, error }) => {
  const classes = useStyles();

  const [user, setUser] = useState({
    username: '',
    password: ''
  });

  const handleChange = e => {
    setUser({
      ...user,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    console.log('user from login handlesubmit', user);
    login(user).then(res => {
      if (res) {
        history.push('/profile');
      }
    });
  };

  return (
    <div className="login-form-container">
      <h3>Log In</h3>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          id="outlined-name"
          label="Username"
          name="username"
          className={classes.textField}
          value={user.username}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          autoComplete="name"
        />
        <TextField
          fullWidth
          type="password"
          id="outlined-name"
          label="Password"
          name="password"
          className={classes.textField}
          value={user.password}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          autoComplete="current-password"
        />

        <ActionButton type="submit" text="Log In" />
      </form>
      <div className="sign-up-form-login">
        Need to create an account?{' '}
        <Link to="/sign-up">
          <span>Sign Up →</span>
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    error: state.error
  };
};

export default connect(
  mapStateToProps,
  { login }
)(Login);
